import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

import {
  NDT_ANCHOR_HOST,
  NDT_ANCHOR_INPUTS,
  NDT_BUTTON_HOST,
  NDT_BUTTON_INPUTS,
  NDtAnchorBase,
  NDtButtonBase,
} from './button-base';

@Component({
  selector: 'button[ndt-icon-button]',
  template: '<ng-content></ng-content>',
  inputs: NDT_BUTTON_INPUTS,
  host: NDT_BUTTON_HOST,
  exportAs: 'nDtButton',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NDtIconButton extends NDtButtonBase {}

@Component({
  selector: 'a[ndt-icon-button]',
  template: '<ng-content></ng-content>',
  inputs: NDT_ANCHOR_INPUTS,
  host: NDT_ANCHOR_HOST,
  exportAs: 'nDtButton, nDtAnchor',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NDtIconAnchor extends NDtAnchorBase {}
